import {t} from '@/core/utils/t'
import {documentComponent} from '@/core/utils/t/document-component'

export const doc = documentComponent({
  name: 'TypeaheadStatic',
  description: 'A typeahead for a fixed set of options',
  categories: [],
  props: t.object({
    valueStorePath: t.array(t.string()),
    name: t.string(),
    compact: t.boolean().optional()
  }),
  examples: {
    basic: {
      props: {
        name: 'basic',
        placeholder: 'Basic',
        options: [{value: 'a', name: 'Option A'}, {value: 'b', name: 'Option B'}, {value: 'c', name: 'Option C'}],
        valueStorePath: ['docs', 'typeaheadstatic', 'value']
      },
      description: 'Simple example'
    }
  },
  todo: [ ],
})
